import { Component, OnInit, ViewChild } from '@angular/core';
import { PasswordChange } from '../password-change';
import { ActivatedRoute } from '@angular/router';
import { PasswordRecoveryService } from '../password-recovery.service';
import { faUser, faLock, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('newPasswordForm', {static: false}) newPasswordForm: any;
  success = '';
  error = '';
  hidePassword = true;
  hideNewPassword = true;
  passwordChange: PasswordChange = {
    token: '',
    oldPassword: '',
    newPassword: '',
    verifyPassword: '',
    username: ''
  }
  faUser = faUser;
  faLock = faLock;
  faEyeSlash = faEyeSlash;
  faEye = faEye;


  constructor(private route: ActivatedRoute,
              private passwordRecoveryService: PasswordRecoveryService) { }

  ngOnInit(): void {
  }

  onPwChange(e) {
    if (this.passwordChange.newPassword && this.passwordChange.verifyPassword) {
      if (this.passwordChange.newPassword !== this.passwordChange.verifyPassword) {
        this.newPasswordForm.controls['verifyPassword'].setErrors({'mismatch': 'Passwords don\'t match'});
      }
      else {
        this.newPasswordForm.controls['verifyPassword'].updateValueAndValidity(true, true);
      }
    }
  }

  onSubmit() {
    this.error = "";
    const clonedPasswordChange = Object.assign({}, this.passwordChange);
    if (!this.hideNewPassword) {
      clonedPasswordChange.verifyPassword = clonedPasswordChange.newPassword;
    }
    this.passwordRecoveryService.change(clonedPasswordChange).subscribe(result => {
      this.success = result.message;
    }, error =>{
      if (error.error instanceof ErrorEvent) {
        this.error = `Error: ${error.error.message}`;
      } else {
        this.error = `Error: ${error.error}`;
      }
    });
  }

  toggleHidePassword() {
    this.hidePassword = !this.hidePassword;
  }

  toggleHideNewPassword() {
    this.hideNewPassword = !this.hideNewPassword;
  }

}
